module.exports = __webpack_public_path__ + "img/map@2x.88138cb7.png";